import { useQuery } from '@tanstack/react-query'
import { getFontFamiliesAll } from '@/api/services/font-family.service'
import { getWpcauthForExternalApi } from '@/api/services/auth.service'
import { queryKeys } from '@/api/query-keys'
import type { FontFamily } from '@/api/types/font-family'

export function useUsedFontFamiliesQuery(spreadId?: string) {
  const hasAuth = typeof window !== 'undefined' && Boolean(getWpcauthForExternalApi())
  const hasSpread = Boolean(spreadId && spreadId.length > 0)

  return useQuery({
    queryKey: queryKeys.fontFamilies.used(spreadId),
    queryFn: async () => {
      const res = await getFontFamiliesAll(spreadId)

      return res.payload
    },
    enabled: hasAuth && hasSpread,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}

export function sortFontFamiliesByDisplayName(families: FontFamily[]): FontFamily[] {
  return [...families].sort((a, b) =>
    (a.displayName ?? '').localeCompare(b.displayName ?? '', undefined, { sensitivity: 'base' })
  )
}
